module.exports = __webpack_public_path__ + "img/bg-6@2x.cd85a89c.png";